export default "__VITE_ASSET__BkO_JC5a__"